<div class="container">
  <div class="d-flex w-100 justify-content-end cursor-pointer" (click)="closePopup()"><mat-icon>close</mat-icon></div>
  <!-- Steps Navigation -->
  <div class="steps-nav">
    <div class="step" [class.active]="currentStep === 1" (click)="goToStep(1)">
      <span class="step-number">1</span>
      <span class="step-label">Basic Information</span>
    </div>
    <div class="step" [class.active]="currentStep === 2" (click)="goToStep(2)">
      <span class="step-number">2</span>
      <span class="step-label">Template</span>
    </div>
    <div class="step" [class.active]="currentStep === 3" (click)="goToStep(3)">
      <span class="step-number">3</span>
      <span class="step-label">Framework</span>
    </div>
    <div class="step" [class.active]="currentStep === 4" (click)="goToStep(4)">
      <span class="step-number">4</span>
      <span class="step-label">Overview</span>
    </div>
  </div>


  <!-- Header -->
  <!-- <div class="header">
    <input type="text" [(ngModel)]="templateData.title" class="title-input" placeholder="Enter Template Title">
  </div> -->



  <div class="header">
    <label for="templateTitle" class="field-label">
      Template Title <span class="required">*</span>
    </label>
    <input id="templateTitle" type="text" [(ngModel)]="templateData.title" class="title-input"
      placeholder="Enter Template Title" />
  </div>



  <!-- STEP 1: Basic Information -->
  <div *ngIf="currentStep === 1" class="step-content">

    <!-- Image Upload -->
    <div class="image-container">
      <div class="image-preview" *ngIf="templateData.imageUrl.length > 0; else uploadPlaceholder">
        <div class="upload-container">
          <!-- Media Preview with Remove Option -->
          <div class="preview-container" *ngIf="templateData.imageUrl.length">
            <div *ngFor="let mediaUrl of templateData.imageUrl" class="media-preview">
              <div class="media-preview-wrapper">
                <img [src]="mediaUrl" class="preview-media" alt="Image Preview" />
                <video *ngIf="isVideo(mediaUrl)" [src]="mediaUrl" class="preview-media" controls></video>
                <mat-icon class="remove-img" (click)="removeMedia(mediaUrl)">close</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #uploadPlaceholder>
        <div class="image-upload-placeholder">
          <span>Upload a Media</span>
        </div>
      </ng-template>

      <div class="image-upload">
        <!-- Media Selector Button -->
        <button (click)="openMediaSelector()" class="upload-btn secondary">
          <ng-container *ngIf="!isUploading; else uploadingTpl">
            Select Media <span class="required">*</span>
          </ng-container>
          <ng-template #uploadingTpl>
            <div class="spinner">
              <span class="loader"></span> Loading...
            </div>
          </ng-template>
        </button>
      </div>
    </div>

    <!-- Description -->
    <h2 class="description-label"> Description<span class="required">*</span></h2>
    <textarea [(ngModel)]="templateData.description" class="text-input" rows="3"
      placeholder="Enter description"></textarea>

    <!-- Industry Selection -->
    <div class="column">
      <h3 class="subindustry-label">Sub-Industry <span class="required">*</span></h3>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-select [(ngModel)]="templateData.selectedSubIndustry" (selectionChange)="onSubIndustryChange($event.value)"
          [compareWith]="compareSubIndustries" required placeholder="Select Sub-Industry">
          <mat-option *ngFor="let sub of activeSubIndustries" [value]="sub">
            {{ sub.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Category and Goals Selection -->
    <div class="row">
      <!-- Category Single Selection -->
      <div class="column">
        <h3>Category <span class="required">*</span></h3>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [(ngModel)]="selectedCategory" (selectionChange)="onCategoryChange($event.value)" name="category"
            placeholder="Select Category">
            <mat-option *ngFor="let cat of categoriesData" [value]="cat">
              {{ cat.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="column">
        <h3>Season</h3>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [(ngModel)]="selectedSeasons" multiple (selectionChange)="onSeasonChange()" name="season"
            placeholder="Select Season">
            <mat-option *ngFor="let season of listSeasons" [value]="season.value">
              {{ season.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Goals Multi-Selection -->
      <div class="column">
        <h3>Goals</h3>
        <mat-form-field appearance="outline" style="width: 100%;">
          <!-- <mat-label>Select Goals</mat-label> -->
          <mat-select [(ngModel)]="selectedGoalIds" multiple (selectionChange)="onGoalsChange($event.value)"
            name="goals" placeholder="Select Goals">
            <mat-option *ngFor="let goal of goalsData" [value]="goal.id">
              {{ goal.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span class="chip" *ngFor="let goal of templateData.goals">
          {{ goal.name }}
          <span class="remove-chip" (click)="removeGoal(goal.id)">×</span>
        </span>
      </div>

      <div class="column">
        <h3>Platforms</h3>


        <!-- Dropdown to select platforms -->
        <mat-form-field appearance="outline" style="width: 100%;">
          <!-- <mat-label>Select Platform</mat-label> -->
          <mat-select [(ngModel)]="selectedPlatform" (selectionChange)="selectPlatform($event.value)" name="platform"
            placeholder="Select Platform">
            <mat-option *ngFor="let platform of platformsData" [value]="platform">
              {{ platform }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span class="chip" *ngFor="let platform of templateData.platform">
          {{ platform }}
          <span class="remove-chip" (click)="removePlatform(platform)">×</span>
        </span>
      </div>





    </div>
    <!-- Specifications & CTA -->
    <div class="row">
      <div class="column">
        <h3>Specifications</h3>
        <input type="text" [(ngModel)]="templateData.specifications" class="text-input"
          placeholder="Enter specifications">
      </div>
      <div class="column">
        <h3>Call to Action</h3>
        <input type="text" [(ngModel)]="templateData.callToAction" class="text-input"
          placeholder="Enter call to action">
        <!-- <button class="cta">{{templateData.callToAction || 'Call to Action'}}</button> -->
      </div>
    </div>

    <!-- Best Channels -->
    <div class="row">
      <!-- <div class="column">
        <h3>Best Channels</h3>
        <div class="chips-container">
          <span class="chip" *ngFor="let channel of templateData.bestChannels">
            {{channel}}
            <span class="remove-chip" (click)="removeChannel(channel)">×</span>
          </span>
        </div>
        <div class="add-item">
          <input type="text" [(ngModel)]="newChannel" placeholder="Add channel" class="text-input-sm">
          <button (click)="addChannel()" class="add-btn">Add</button>
        </div>
      </div> -->
    </div>

    <!-- Tags -->
    <h3>Tags</h3>
    <div class="chips-container">
      <span class="chip" *ngFor="let tag of templateData.tags">
        {{tag}}
        <span class="remove-chip" (click)="removeTag(tag)">×</span>
      </span>
    </div>
    <div class="add-item">
      <input type="text" [(ngModel)]="newTag" placeholder="Add tag" class="text-input-sm">
      <button (click)="addTag()" class="add-btn">Add</button>
    </div>

  </div>

  <!-- STEP 2: Template -->
  <div *ngIf="currentStep === 2" class="step-content">
    <h2>Fill-in-the-Blank Template</h2>
    <textarea [(ngModel)]="templateData.templateText" class="template-box textarea-editable"
      placeholder="Enter your template text here..." rows="10"></textarea>
  </div>

  <!-- STEP 3: Framework -->
  <div *ngIf="currentStep === 3" class="step-content">
    <h2>Strategy</h2>
    <textarea [(ngModel)]="templateData.hookStrategy" class="text-input" rows="3"
      placeholder="Enter your strategy"></textarea>
    <h2>Content Structure</h2>
    <textarea [(ngModel)]="templateData.contentStructure" class="template-box textarea-editable"
      placeholder="Enter content Structure details..." rows="10"></textarea>
  </div>

  <!-- STEP 4: Overview -->
  <div *ngIf="currentStep === 4" class="step-content">
    <h2>Preview</h2>

    <!-- Header Preview -->
    <div class="preview-header">
      <h1>{{templateData.title || 'Template Title'}}</h1>
    </div>

    <!-- Media Upload and Preview -->
    <div class="upload-container">
      <!-- Media Preview -->
      <div class="preview-container" *ngIf="templateData.imageUrl.length">
        <div *ngFor="let mediaUrl of templateData.imageUrl" class="media-preview">
          <img *ngIf="isImage(mediaUrl)" [src]="mediaUrl" class="preview-media" alt="Image Preview" />
          <video *ngIf="isVideo(mediaUrl)" [src]="mediaUrl" class="preview-media" controls></video>
        </div>
      </div>

    </div>

    <!-- Description Preview -->
    <div class="preview-section">
      <h2>Description</h2>
      <p>{{templateData.description || 'Description will appear here'}}</p>
    </div>


    <!-- Industry & Sub-Industry -->
    <div class="row">
      <div class="column">
        <h3>Industry</h3>
        <span class="chip" *ngIf="templateData.selectedIndustry">{{ templateData.selectedIndustry.name }}</span>
        <span *ngIf="!templateData.selectedIndustry">No industry selected</span>
      </div>
      <div class="column">
        <h3>Sub-Industry</h3>
        <span class="chip" *ngIf="templateData.selectedSubIndustry">{{ templateData.selectedSubIndustry.name }}</span>
        <span *ngIf="!templateData.selectedSubIndustry">No sub-industry selected</span>
      </div>
    </div>



    <!-- Category & Goals Preview -->
    <div class="row">
      <div class="column">
        <h3>Category</h3>
        <span class="chip" *ngIf="selectedCategory">{{selectedCategory.name}}</span>
        <span *ngIf="!selectedCategory">No category selected</span>
      </div>
      <div class="column">
        <h3>Goals</h3>
        <span class="chip" *ngFor="let goal of templateData.goals">{{goal.name}}</span>
        <span *ngIf="templateData.goals.length === 0">No goals selected</span>
      </div>
    </div>


    <!-- Specifications & CTA Preview -->
    <div class="row">
      <div class="column">
        <h3>Specifications</h3>
        <p>{{templateData.specifications || 'Specifications will appear here'}}</p>
      </div>
      <div class="column">
        <h3>Call to Action</h3>
        <button class="cta">{{templateData.callToAction || 'Call to Action'}}</button>
      </div>
    </div>

    <!-- Channels Preview -->
    <div class="row">
      <div class="column">
        <h3>Best Channels</h3>
        <span class="chip" *ngFor="let platform of templateData.platform">{{platform}}</span>
        <span *ngIf="templateData.platform.length === 0">No channels added</span>
      </div>
    </div>

    <!-- Tags Preview -->
    <h3>Tags</h3>
    <span class="chip" *ngFor="let tag of templateData.tags">{{tag}}</span>
    <span *ngIf="templateData.tags.length === 0">No tags added</span>

    <!-- Template Text Preview -->
    <div class="preview-section" *ngIf="templateData.templateText">
      <h3>Template Text</h3>
      <pre class="template-box">{{templateData.templateText}}</pre>
    </div>

    <!-- Framework Preview -->
    <div class="preview-section" *ngIf="templateData.hookStrategy">
      <h3>Strategy</h3>
      <pre class="template-box">{{templateData.hookStrategy}}</pre>
    </div>

    <!-- Content Structure Preview -->
    <div class="preview-section" *ngIf="templateData.contentStructure">
      <h3>Content Structure</h3>
      <pre class="template-box">{{templateData.contentStructure}}</pre>
    </div>

  </div>

  <!-- Action Buttons -->
  <div class="footer">
    <button class="cancel-btn" *ngIf="currentStep === 1" (click)="cancel()">Cancel</button>
    <div class="spacer" *ngIf="currentStep !== 1"></div>
    <div class="step-buttons">
      <!-- Previous -->
      <button class="prev-btn" *ngIf="currentStep > 1" (click)="previousStep()">Previous</button>

      <!-- Step 1: Next (disabled until required fields are filled) -->
      <button class="next-btn" *ngIf="currentStep === 1" (click)="nextStep()" [disabled]="!isStep1Valid()">
        Next
      </button>



      <!-- Step 2 -->
      <button class="next-btn" *ngIf="currentStep === 2" (click)="nextStep()">Next</button>

      <!-- Step 3 -> Review -->
      <button class="create-btn" *ngIf="currentStep === 3" (click)="nextStep()">Review</button>

      <!-- Step 4: Create / Update -->
      <button class="create-btn" *ngIf="currentStep === 4 && !isEditMode" (click)="createTemplate()"
        [disabled]="!isStep4Valid()">
        Create Template
      </button>


      <button class="create-btn" *ngIf="currentStep === 4 && isEditMode" (click)="updateTemplate()"
        [disabled]="!isStep4Valid()">
        Update Template
      </button>
    </div>

  </div>
</div>